import { RiskDTO2 } from "app/shared/models/data/dto/quick-quote/risk-dto2";

export interface BackupState {
  isLoading: boolean | null;
  data: RiskDTO2 | null
}
export const initialState = {
  isLoading: null,
  data: null
}